<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px"
             class="demo-ruleForm">
      <el-row>
        <el-col>
          <el-form-item label="引题:"
                        prop="intitle">
            <el-input v-model="ruleForm.intitle"
                      placeholder="选填，不超过80个字"></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="标题:"
                        prop="title">
            <el-input v-model="ruleForm.title"
                      placeholder="必填，不能超过80个字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="副标题:"
                        prop="subtitle">
            <el-input v-model="ruleForm.subtitle"
                      placeholder="选填，不能超过80个字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-col :span="12">
          <el-form-item label="作者:"
                        prop="author">
            <el-input v-model="ruleForm.author"
                      placeholder="必填，不超过10个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="来源:"
                        prop="source">
            <el-input v-model="ruleForm.source"
                      placeholder="必填，不超过10个字"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:10px;">
        <el-form-item prop="content">
          <div slot="label"
               class="labelclass">
            稿件正文:
            <p>
              <span @click="quickFormat"
                    style="color:#185ED3;cursor: pointer;">一键排版<span style="opacity: 0;">:</span></span>
            </p>
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12}"
                    v-model="ruleForm.content"
                    placeholder="必填，稿件正文不超过200个字"></el-input>
        </el-form-item>
      </el-row>

    </el-form>

    <div class="picbj">
      <div class="picanddesc"
           v-for="(e,i) in choosePic"
           :key="i">
        <div class="pic"
             :style="{backgroundImage:'url(' + e.src +')'}">
          <div class="delete">
            <img @click="picDelete(i)"
                 src="@/assets/container/delete.png"
                 alt="">
          </div>
        </div>
        <el-input style="margin-left:50px;"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6}"
                  v-model="choosePic[i].desc"
                  placeholder="图片描述，5000个字以内"></el-input>
      </div>
    </div>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isSimple ? '#E27B02' : '#194897'}"
                   type="primary">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listAtlasPictures,getPictures
} from "@/api/picture";
import { getDate } from "@/plugins/getdate";
import { picPrefix } from "@/constants/piccommon";
import { getPictureActivityArticle } from '@/api/pictureActivityArticle'
import {
  listAuthRole
} from "@/api/authRole";
export default {
  data () {
    return {
      picPrefix,
      isAct: '',
      choosePic: [],
      roleName: [],
      ruleForm: {
        intitle: '',
        title: '',
        author: '',
        source: '',
        content: '',
        subtitle: ''
        // createAt:''
      },
      rules: {
        intitle: [
          { max: 80, message: '长度不超过80个字符', trigger: 'blur' }
        ],
        subtitle: [
          { max: 80, message: '长度不超过80个字符', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
          { max: 80, message: '长度不超过80个字符', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '请输入作者姓名', trigger: 'change' },
          { max: 10, message: '长度不得超过10个字符', trigger: 'blur' }
        ],
        source: [
          { required: true, message: '请输入来源', trigger: 'change' },
          { max: 10, message: '长度不得超过10个字符', trigger: 'blur' }
        ],
        content: [
          { min: 0, max: 5000, message: '长度不得超过5000个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    async getPictureActivityArticleAsync () {
      let { status, data } = await getPictureActivityArticle(this.$route.query.activityArticleId)
      
      if(status){
        this.ruleForm.title = data.title
        this.ruleForm.content = data.content
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.choosePic.length <= 9) {
            this.$emit('submitForm', this.ruleForm, this.choosePic)
          } else {
            this.$message.warning('限制提交9张图片！')
          }
        } else {
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$router.go(-1)
      // if(this.isAct === true){
      //   this.$router.go(-1)
      // }else{
      //   this.$emit('closeForm')
      // }
    },

    picDelete (i) {
      this.$confirm('确认删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePic.splice(i, 1)
        })
        .catch(e => {

        });
    },


    quickFormat () {
      var content_arr = this.ruleForm.text.replace("\r", "").split("\n");
      var tempcontent = '';
      for (var i = 0; i < content_arr.length; i++) {
        if (content_arr[i].trim() !== "") {
          var temp = "  " + content_arr[i].trim() + "\n\n";
          tempcontent = tempcontent + temp;
        }
      }
      this.ruleForm.text = tempcontent
    },


    //获取图集中所有图片
    async listAtlasPicturesAsync () {
      let { status, data, message } = await listAtlasPictures({ id: this.$route.query.id, page: 0, pageSize: 100 });
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].fileInfo.picThumbH160) {
            data[i].src = picPrefix + data[i].fileInfo.picThumbH160
          } else {
            data[i].src = picPrefix + data[i].fileInfo.savepath
          }
        }
        this.choosePic = data
      }
    },
    //获取图集中所有图片
    async getPics (val) {
      let { status, data, message } = await getPictures({ ids: val});
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].fileInfo.picThumbH160) {
            data[i].src = picPrefix + data[i].fileInfo.picThumbH160
          } else {
            data[i].src = picPrefix + data[i].fileInfo.savepath
          }
        }
        this.choosePic = data
      }
    },

  },
  created () {
    if(this.$route.query.activityArticleId){
      this.getPictureActivityArticleAsync()
    }

    if(this.$route.query.ids){
      this.getPics(this.$route.query.ids)
    }

    let loginInfoString = localStorage.getItem("loginInfo");
    let loginInfoeArray = JSON.parse(loginInfoString)

    this.ruleForm.author = loginInfoeArray.name
    let isDrawer
    let isAct
    if (this.$route.query.isDrawer) {
      isDrawer = this.$route.query.isDrawer

      if (isDrawer === 'false') {
        isDrawer = false
      } else if (isDrawer === 'true') {
        isDrawer = true
      }

      if (isDrawer) {
        let picLoveString = sessionStorage.getItem("picLove");
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          this.choosePic[i].desc = ""
        }
      }
    }
    if (this.$route.query.isSwitch) {
      let isSwitch = this.$route.query.isSwitch

      if (isSwitch === 'false') {
        isSwitch = false
      } else if (isSwitch === 'true') {
        isSwitch = true
      }

      if (!isSwitch) {
        let picLoveString = sessionStorage.getItem("chooseArr");
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          this.choosePic[i].desc = ""
        }

        this.ruleForm.indexpicFileId = this.choosePic[0].id
      }
    }
    if (this.$route.query.isAct) {
      isAct = this.$route.query.isAct
      this.isAct = isAct
      if (isAct === 'false') {
        isAct = false
      } else if (isAct === 'true') {
        isAct = true
      }

      if (isAct) {
        let picLoveString = sessionStorage.getItem("actPic");
        this.choosePic = JSON.parse(picLoveString)
        for (let i = 0; i < this.choosePic.length; i++) {
          this.choosePic[i].desc = ""
          try {
            if (typeof this.choosePic[i].src == 'undefined') {
              this.choosePic[i].src = this.choosePic[i].fileInfo.scr
            }
          } catch (error) {
          }
        }
        console.log(this.choosePic)
      }
    }

    if (this.$route.query.id) {
      this.listAtlasPicturesAsync()
    }

  }
}
</script>

<style lang="scss" scoped>
.picbj {
  padding-top: 20px;
  padding-left: 90px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &:after {
    content: "";
    width: 31%;
    border: 1px solid transparent;
  }
  .picanddesc {
    display: flex;
    align-items: center;
    width: 31%;
    margin-bottom: 20px;

    .pic {
      width: 240px;
      height: 120px;
      border-radius: 6px;
      background-size: cover;
      position: relative;
      &:hover .delete {
        opacity: 1;
      }
      .delete {
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        transition: 0.3s;
        opacity: 0;
      }
    }
  }
}
.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // top: 0;
  // z-index: 99;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}
</style>
